//=====================================================
//　G007：予約確定
//=====================================================

import { useHistory } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ReservationFlow, ProcessName } from "../../common/ReservationFlow";
import { ContentsTitle } from "../../common/ContentsTitle";
import { ReservationInfo } from "../../common/ReservationInfo";
import { useContext, useEffect } from "react";
import { CtxClinicInfo, CtxNewReservation } from "../../utils/Contexts";
import { ReservationType } from "../../utils/ConstCommon";

export function G007(){

    const history = useHistory();
    const cci = useContext(CtxClinicInfo);
    const cnr = useContext(CtxNewReservation);

    // マイページ遷移フラグ
    const isGotoMypage = [
        ReservationType.Return, // 再診
        ReservationType.Change, // 変更
        ReservationType.ReFirst // 再初診
    ].indexOf(cnr.type) >= 0;

    const txtGotoMypage = "Web予約マイページへ";
    const txtGotoTop = "Web予約トップへ";

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 予約確定";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 予約確定";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <ReservationFlow currentProcess={ProcessName.Complete} />
            <ContentsBox>
                <ContentsTitle title="以下の内容でご予約が確定しました" />
                <ReservationInfo />
                {isGotoMypage 
                    ? <BtnSubmit title={txtGotoMypage} onClick={function(){ history.push("/mypage"); }} /> 
                    : <BtnSubmit title={txtGotoTop} onClick={function(){ history.push("/"); }} /> 
                }
                
            </ContentsBox>
        </>
    );

}